import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";
import { FileText, Image as ImageIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Documents() {
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/documents");
        setDocs(data?.documents || data || []);
      } finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <div className="space-y-3"><Skeleton className="h-8 w-40" /><Skeleton className="h-24 w-full" /></div>;

  return (
    <div className="space-y-6" data-testid="documents-page">
      <div>
        <h1 className="text-3xl md:text-4xl font-semibold tracking-tight">Documents</h1>
        <p className="text-neutral-600 mt-1 text-sm">{docs.length} file{docs.length !== 1 ? "s" : ""} in your Memora.</p>
      </div>
      {docs.length === 0 && (
        <div className="text-neutral-500 text-sm">Nothing uploaded yet. Head to Add to start.</div>
      )}
      <div className="space-y-2">
        {docs.map((d, idx) => (
          <div
            key={d.id || d.document_id || d.filename || idx}
            data-testid={`doc-${d.id || d.document_id || idx}`}
            className="bg-white rounded-xl border border-neutral-200 p-3 flex items-start gap-3"
          >
            {String(d.mime_type || "").startsWith("image/") ? (
              <ImageIcon className="w-4 h-4 text-neutral-400 mt-1" />
            ) : (
              <FileText className="w-4 h-4 text-neutral-400 mt-1" />
            )}
            <div className="flex-1 min-w-0">
              <div className="font-medium truncate">{d.title || d.filename}</div>
              <div className="text-xs text-neutral-500 mt-0.5">
                {d.uploaded_at?.slice(0, 10) || ""}
                {d.status ? ` · ${d.status}` : ""}
              </div>
              {d.extracted_summary && (
                <div className="text-sm text-neutral-700 mt-1 line-clamp-2">{d.extracted_summary}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
